<template>
  <div class="error">
    <div>
      <p>{{ 'errors.' + error + '.title' | trans }}</p>
      <p class="cat"><small>{{ 'errors.cat' | trans }}</small></p>
      <router-link
        class="btn lg"
        :to="{name:'dashboard'}">
        {{ 'home' | trans }}
      </router-link>
    </div>
  </div>
</template>

<script>
  import background from '@/assets/img/404.jpg'
  
  export default {
    name: 'Error',
    props: {
      error: {
        default: '404',
      }
    },
  }
</script>

<style lang="scss">
  @import './assets/scss/fix';
  @import './assets/scss/common';
  
  //$bgimgratio: 1267/1008;
  div.error {
    margin-top: -$breadcrumbs-height;
    min-height: 100vh;
    text-align: center;
    background: white url('assets/img/404.jpg') no-repeat center bottom;
    background-size: contain;
    > div {
      margin-right: 34vh;
      font-size: 26px;
      color: #746963;
      line-height: 1.3;
      p {
        margin: 0;
        small {
          font-size: 0.8125em;
        }
      }
      .btn {
        text-transform: uppercase;
        font-weight: 700;
        padding-left: 40px;
        padding-right: 40px;
        border-radius: 30px;
        margin-top: 12px;
      }
    }
    @media (min-aspect-ratio: 1267/1008) {
      > div {
        padding-top: 48vh;
        @media (min-height: 700px) {
          font-size: 32px;
        }
      }
    }
    @media (max-aspect-ratio: 1267/1008) {
      > div {
        padding-top: calc(100vh + #{-100vw + 48vw*1267/1008});
        @media (min-width: 700px) {
          font-size: 32px;
        }
        @media (max-width: 480px) {
          font-size: 22px;
        }
      }
      @media (max-width: $sm-max) {
        //faded background
        background-image: linear-gradient(to bottom, rgba(white, .5), rgba(white, .5)), url('assets/img/404.jpg');
        > div {
          margin-right: 0 !important;
        }
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/Error.vue